// extracted by mini-css-extract-plugin
export var labelWrapper = "_fa-0";